// src/Pages/Imweb/ImwebEntry.jsx
import React, { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

const ImwebEntry = () => {
    const [searchParams] = useSearchParams();

    useEffect(() => {
        // 아임웹에서 넘어온 siteCode 추출
        const siteCode = searchParams.get('siteCode') || searchParams.get('site_code');

        if (!siteCode) {
            console.error('siteCode가 없습니다. 아임웹을 통해 접근해주세요.');
            return;
        }

        // OAuth 인증 시작
        startOAuth(siteCode);
    }, [searchParams]);

    const startOAuth = (siteCode) => {
        // 백엔드에서 검증 및 siteCode 추출을 위해 state에 조합해 둡니다.
        const state = `${siteCode}_${generateRandomString()}`;
        
        // 도메인 주의: openapi.imweb.me
        const authBaseUrl = 'https://openapi.imweb.me/oauth2/authorize'; 
        
        // 필요한 권한(scope)을 띄어쓰기로 구분해서 적습니다. 
        // 앱 성격에 따라 필요한 권한만 남기고 수정하세요.
        const scope = "site-info:read site-info:write script:read script:write";
        
        // 파라미터명 주의: 카멜케이스(camelCase) 사용
        const authUrl = 
            `${authBaseUrl}?` +
            `responseType=code&` +
            `clientId=${process.env.REACT_APP_IMWEB_CLIENT_ID}&` +
            `redirectUri=${encodeURIComponent(process.env.REACT_APP_IMWEB_REDIRECT_URI)}&` +
            `scope=${encodeURIComponent(scope)}&` +
            `state=${encodeURIComponent(state)}&` +
            `siteCode=${siteCode}`;
        
        console.log('아임웹 OAuth 인증 시작:', authUrl);
        window.location.href = authUrl;
    };

    const generateRandomString = () => {
        return Math.random().toString(36).substring(2, 15) + 
               Math.random().toString(36).substring(2, 15);
    };

    return (
        <div className="min-h-screen flex items-center justify-center bg-gray-50">
            <div className="flex flex-col items-center space-y-4">
                <div className="w-8 h-8 border-2 border-green-500 border-t-transparent rounded-full animate-spin"></div>
                <div className="text-gray-600 font-medium text-sm">아임웹과 연결하는 중...</div>
            </div>
        </div>
    );
};

export default ImwebEntry;